
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#CCCEDC","d":"M8.74 12.313H4.594a4.094 4.094 0 100 8.187H8.74a4.094 4.094 0 000-8.188zm13.96 0h-6.733a.8.8 0 00-.8.8V19.7a.8.8 0 00.8.8H22.7a.8.8 0 00.8-.8v-6.587a.8.8 0 00-.8-.8zM22.7.5H1.3a.8.8 0 00-.8.8v6.587a.8.8 0 00.8.8h21.4a.8.8 0 00.8-.8V1.3a.8.8 0 00-.8-.8z"}}),_c('path',{attrs:{"fill":"#CCCEDC","fill-rule":"nonzero","d":"M20.847 15.281a.65.65 0 11.937.902l-1.946 2.022a.65.65 0 01-.927.01l-1.367-1.346a.65.65 0 01.83-.994l.082.068.901.887zM6 3.944h12a.65.65 0 01.096 1.293L18 5.244H6a.65.65 0 01-.096-1.293L6 3.944h12z"}}),_c('ellipse',{attrs:{"cx":"4.667","cy":"16.406","fill":"#CCCEDC","fill-rule":"nonzero","rx":"2","ry":"1.969"}})])])
          )
        }
      }
    